<template>
  <div class="dqyxfx-warp" v-if="showpage">
    <div class="left-content" v-show="tabShow">
      <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
      <el-tree
        class="filter-tree"
        :data="leftTreeData"
        node-key="id"
        :props="defaultProps"
        default-expand-all
        :highlight-current="true"
        :filter-node-method="filterNode"
        :expand-on-click-node="false"
        ref="tree"
        @node-click="handleNodeClick"
      ></el-tree>
    </div>
    <div class="right-content" :style="{width:tabShow?'calc(100% - 260px)':'100%'}">
      <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
      <div class="search-box box" style="height: 36px;line-height: 36px;">
        <time-search
          ref="timeSearch"
          :control="{data:timeData}"
          @timeControlChange="timeControlChange"
          @timeControlClick="TimeControlClick"
        >
          <el-button
            type="primary"
            size="mini"
            style="margin-left:10px;"
            class="btn"
            @click="saveProject"
          >保存方案</el-button>
          <el-button type="primary" size="mini" class="btn" @click="PlanRecord">方案记录</el-button>
        </time-search>
      </div>
      <div class="pane">
        <div class="echarts-warp">
          <div class="toptitle">
            <div class="topcontent" style="
background: linear-gradient(180deg, #E8F8FF 0%, #CCEEFF 100%);">
              <div>最大需量（kW）</div>
              <div>{{maxValue}}</div>
            </div>
            <div class="topcontent" style="
background: linear-gradient(180deg, #DDF4ED 0%, #B8E6D6 100%);">
              <div>实际基本电费（元）</div>
              <div>{{maxCost}}</div>
            </div>
            <div class="topcontent" style="
background: linear-gradient(180deg, #F4F4CE 0%, #E6E6A1 100%);">
              <div>调整后基本电费（元）</div>
              <div>{{maxValueTwo}}</div>
            </div>
            <div class="topcontent" style="
background: linear-gradient(180deg, #E8E4FB 0%, #CCC4F5 100%);">
              <div>节省电费（元）</div>
              <div>{{Cost}}</div>
            </div>
          </div>
          <div class="echart-content">
            <div class="lineEchart">
              <lineEchart ref="chartFirst" v-if="topechart" :data="topechart"></lineEchart>
            </div>

            <div class="lineEchart" v-for="(item ,index) in echartData" :key="index">
              <lineEchart :data="item"></lineEchart>
            </div>
          </div>
          <div class="table">
            <el-table
              :header-cell-style="tableHeaderColor"
              :data="tableData"
              border
              style="width: 100%"
            >
              <el-table-column
                :show-overflow-tooltip="true"
                prop="measureId"
                label="检测点id"
                width="180"
                v-if="false"
              ></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="name" label="检测点名称" width="180"></el-table-column>
              <el-table-column prop="demandType" label="调整方式">
                <template slot-scope="scope">
                  <div class="block">
                    <el-slider
                      @change="changeSlider(scope.row,scope.$index)"
                      v-model="scope.row.demandType"
                      :show-tooltip="false"
                      :step="1"
                      show-stops
                      :min="-12"
                      :max="12"
                      :marks="marks"
                      style="margin-bottom:20px"
                    ></el-slider>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="bottomtable">
            <el-table
              :header-cell-style="tableHeaderColor"
              :data="tableDataTwo"
              border
              style="width: 100%"
            >
              <el-table-column prop="name" label="名称" align="center"></el-table-column>
              <el-table-column prop="maxValue" label="最大需量（kW）" align="center"></el-table-column>
              <el-table-column prop="timeTwo" label="最大需量发生时间" align="center"></el-table-column>
              <el-table-column prop="maxCost" label="基本电费" align="center"></el-table-column>
              <el-table-column prop="Cost" label="基本电费差额" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <el-dialog title="新增方案" :visible.sync="dialogVisible" width="500px" :destroy-on-close="true">
        <el-form ref="form" :model="form" label-width="100px" :rules="rules">
          <el-form-item label="方案名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注信息">
            <el-input
              type="textarea"
              placeholder="请输入备注信息"
              v-model="form.displayName"
              maxlength="300"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updata">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
  <div v-else-if="!showpage">
    <xlpage :checknode="fistcheck" @backpage="backpage(arguments)"></xlpage>
  </div>
</template>

<script>
import NkTable from "@/components/common/NkTable.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";

import * as utils from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import { isNull, isUndefined } from "util";
import xlpage from "./echart/xlpage";
import lineEchart from "./echart/lineEchart";
import dataJS from "./echart/dataJS.js";
import { runInThisContext } from "vm";

let eleTimeData = [
  {
    type: "day",
    label: "日",
  },
];
export default {
  components: {
    BtnShow,
    lineEchart,
    TimeSearch,
    xlpage,
  },
  computed: {},
  data() {
    return {
      tabShow: true,
      timeData: eleTimeData,
      selectedDate: {
        startTime: "",
        endTime: "",
      },
      treeTabObj: null,
      leftTreeData: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      filterText: "",
      selectNode: [],
      defaultCheckedKeys: [],
      timeType: [{ value: "0", label: "日" }],
      harmonic: "1",
      computedNum: [
        { value: "1", label: "电压" },
        {
          value: "2",
          label: "电流",
        },
      ],
      elem: null,
      chartDataV: [],
      chartDataA: [],
      unit: "",
      timeTitle: "",
      showEleWork: false,
      eleWorkObj: {},
      measure: [],
      isDoubleY: false,
      myChart: null,
      myCharttwo: null,
      title: ["日平均负荷率"],
      titlename: "日平均负荷率曲线图",
      value2: 0,
      showcontent: true,
      warnValue: 85,
      changecolor: true,
      tableData: [],
      tableDataTwo: [],
      marks: {
        "-12": "12",
        "-11": "11",
        "-10": "10",
        "-9": "9",
        "-8": "8",
        "-7": "7",
        "-6": "6",
        "-5": "5",
        "-4": "4",
        "-3": "3",
        "-2": "2",
        "-1": "1",
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: {
          style: {
            left: "98%",
          },
          label: "12",
        },
      },
      dialogVisible: false,
      form: {
        name: "",
        displayName: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
      },
      showpage: true,
      fistcheck: null,
      backcheck: null,
      allechartdata: null,
      allechartdataTwo: null,
      originalData: null,
      echartData: null,
      topechart: null,
      toalData: [],
      toalDataTwo: [],
      maxValue: "-",
      maxCost: "-",
      maxValueTwo: "-",
      Cost: "-",
      tablebottomData: null,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.init();
  },
  mounted() {
    let vm = this;
    vm.$eventBus.$on("changeCompanyId", (companyId) => {
      vm.init();
    });
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return "background-color: #F3F3F3;color: #666;font-size:14px";
      }
    },
    init() {
      console.log();
      let vm = this;
      vm.bindGetTreeTabCode();
    },
    timeControlChange(e) {
      let vm = this;
      vm.selectedDate = e;
    },
    TimeControlClick(e) {
      let vm = this;
      vm.selectedDate = e;
      vm.getData();
    },
    bindGetTreeTabCode() {
      let vm = this;
      // vm.viewId = e.code;
      vm.$api.orgStructNode.getORGStructNodes(this.$store.state.user.currentCompanyId).then((res) => {
        vm.leftTreeData = this.toTree(JSON.parse(JSON.stringify(res.data)), 0);
        vm.selectNodes = [vm.leftTreeData[0]];
        //设置默认选中第一个
        vm.defaultCheckedKeys = [vm.leftTreeData[0].id];
        vm.fistcheck = vm.leftTreeData[0];
        vm.$nextTick((callback) => {
          vm.$refs.tree.setCurrentKey(vm.leftTreeData[0].id);
        });
        vm.getData();
      });
    },
    handleNodeClick(e) {
      this.fistcheck = e;
      this.selectNodes = [e];
      this.getData();
    },

    getData() {
      let vm = this;
      const element = vm.selectNodes[0];

      vm.$api.nhtj
        .getAllDemandByOrg(
          vm.selectedDate.startTime,
          vm.selectedDate.endTime,
          element.id,
          "IsTransformer",
          0
        )
        .then((res) => {
          let arr = res.data;
          vm.originalData = res.data;
          vm.getbottomEchart(arr); //6

          vm.getTopEchart(arr); //总

          vm.tableData = [];
          for (let b = 0; b < res.data.length; b++) {
            vm.tableData.push({
              measureId: res.data[b].measureId,
              name: res.data[b].measureName,
              demandType: 0,
            });
          }
          vm.gettableBottom();
        });
    },
    gettableBottom() {
      let vm = this;
      const element = vm.selectNodes[0];
      vm.$api.nhtj
        .getPointedDemandSchemeInfo(element.id, 0, vm.selectedDate.startTime)
        .then((res) => {
          let aaa;
          vm.tablebottomData = res.data;
          let arrNew = [];

          for (let j = 0; j < res.data[0].detail.length; j++) {
            aaa = this.changeTable(res.data[0].detail[j], j);
          }
          aaa.name = res.data[0].name;
          arrNew.push(aaa); //[{}]
          let bbb = JSON.parse(JSON.stringify(aaa));

          arrNew.push(bbb);
          // for (let i = 0; i < res.data.length; i++) {
          //   for (let j = 0; j < res.data[i].detail.length; j++) {
          //     aaa = this.changeTable(res.data[i].detail[j], j);
          //   }
          //   aaa.name = res.data[i].name;
          //   arrNew.push(aaa); //[{}]
          // }
          console.log(arrNew);
          if (arrNew.length != 0) {
            arrNew[0].name = "实际需量";
            arrNew[1].name = "调整后需量";
          }
          vm.$api.nhtj
            .getCapacitySum(element.id, 0, "IsTransformer")
            .then((res) => {
              console.log(res);
              arrNew.push(res.data);
            });
          vm.tableDataTwo = arrNew;
        });
    },
    //各个设备的需量数据
    getbottomEchart(e) {
      let vm = this;
      let arr = e;
      let obj = {
        legend: [],
        series: [],
        length: [],
      };
      let resData = [];
      for (let i = 0; i < arr.length; i++) {
        resData.push({
          legend: [],
          series: [],
          length: [], //
        });
        resData[i].legend.push(arr[i].measureName);
        resData[i].series.push({
          data: [],
          name: arr[i].measureName,
          type: "line",
          smooth: true,
        });
        for (let j = 0; j < arr[i].data.length; j++) {
          resData[i].length.push(arr[i].data[j].time);
          resData[i].series[0].data.push(arr[i].data[j].value.toFixed(2));
        }
        resData[i].legend[1] = JSON.parse(JSON.stringify(resData[i].legend[0]));
        resData[i].series[1] = JSON.parse(JSON.stringify(resData[i].series[0]));
        resData[i].legend[0] = resData[i].legend[0] + "实际需量";
        resData[i].legend[1] = resData[i].legend[1] + "调整后需量";
        resData[i].series[0].name = resData[i].series[0].name + "实际需量";
        resData[i].series[0].color = resData[i].series[0].color =["#0080FF"];
        resData[i].series[1].name = resData[i].series[1].name + "调整后需量";
        resData[i].series[1].color = resData[i].series[1].color =["#CCCC00"];
      }

      // console.log(resData);
      vm.echartData = resData;
      // for (let i = 0; i < arr.length; i++) {
      //   obj.legend.push(arr[i].measureName);
      //   obj.series.push({
      //     data: [[],[]],
      //     name: arr[i].measureName,
      //     type: "line",
      //     smooth: true
      //   });

      //   for (let j = 0; j < arr[i].data.length; j++) {
      //     obj.series[i].data.push(arr[i].data[j].value.toFixed(2));
      //   }
      // }
      // for (let a = 0; a < arr[0].data.length; a++) {
      //   obj.length.push(arr[0].data[a].time);
      // }
      // console.log(obj);
      // vm.getEchartTwo(obj);
    },
    //总设备的需量数据
    getTopEchart(e) {
      console.log(e);
      let vm = this;
      let Alldata = [];
      this.toalData = [];
      this.toalDataTwo = [];
      for (let i = 0; i < e.length; i++) {
        Alldata.push(e[i].data);
        vm.toalData.push(e[i].data);
        vm.toalDataTwo.push(e[i].data);
      }
      console.log(Alldata);
      // console.log(vm.getAlldata(Alldata));
      vm.allechartdata = vm.getAlldata(Alldata);
      vm.allechartdataTwo = vm.getAlldata(Alldata);
      let allobj = {
        title: "实际需量与调整需量",
        legend: ["实际需量", "调整后需量"],
        color: ["#00AAFF", "#52CCA3"],
        series: [
          {
            name: "实际需量",
            data: [],
            type: "line",
              color: ["#0080FF"],
            smooth: true,
          },
          {
            name: "调整后需量",
            data: [],
            type: "line",
            color: ["#CCCC00"],
            smooth: true,
          },
        ],
        length: [],
      };
      for (let z = 0; z < vm.allechartdata.length; z++) {
        allobj.series[0].data.push(vm.allechartdata[z].value.toFixed(2));
        allobj.series[1].data.push(vm.allechartdata[z].value.toFixed(2));
        allobj.length.push(vm.allechartdata[z].time);
      }
      console.log(allobj);
      vm.topechart = allobj;
      vm.getTableData();
      // vm.getEchart(allobj);
    },
    //滑块拖动触发数据改变
    changeSlider(e, index) {
      let vm = this;
      console.log(e);
      console.log(index);
      console.log(this.originalData);
      console.log(this.echartData);
      let indexIndex;
      let oldData = JSON.parse(JSON.stringify(this.originalData));
      let newData = [];
      let afterData = [];
      oldData.map((item, index) => {
        if (e.name == item.measureName) {
          let sj = dataJS.overTimeToArr(item.data, e.demandType);
          vm.toalData[index] = sj;
          console.log(sj);
          sj.forEach((item) => {
            afterData.push(item.value.toFixed(2));
          });
          for (let i = 0; i < sj.length; i++) {
            newData.push(sj[0].value);
          }
        }
      });

      console.log(afterData);

      this.echartData.forEach((item) => {
        //[1.2.3.4.5.6]   2
        indexIndex = item.series[1].name.indexOf(e.name); //2
        if (indexIndex > -1) {
          console.log(item);
          // item.series[1].data=newData
          // console.log(item)
        }
      });
      console.log(afterData);
      console.log(this.echartData[index].series);
      let echartData = JSON.parse(JSON.stringify(this.echartData));

      echartData[index].series[1].data = afterData;
      this.echartData = echartData;

      let tzData = [];
      this.echartData.forEach((item) => {
        //[1.2.3.4.5.6]   2
        tzData.push(item.series[1].data);
      });

      console.log(vm.toalData);
      let allechartdata = vm.getAlldata(vm.toalData);
      vm.allechartdataTwo = allechartdata;
      console.log(allechartdata);
      let allobj = JSON.parse(JSON.stringify(vm.topechart));
      allobj.series[1].data = [];

      for (let z = 0; z < allechartdata.length; z++) {
        allobj.series[1].data.push(allechartdata[z].value.toFixed(2));
      }

      console.log(allobj);
      vm.topechart = allobj;
      vm.getTableData();
    },

    //数据改变
    changeTable(item, index) {
      let vm = this;
      let e = JSON.parse(JSON.stringify(item));
      // console.log(e);
      // console.log(index);
      // console.log(this.originalData);
      // console.log(this.echartData);
      let indexIndex;
      let oldData = JSON.parse(JSON.stringify(this.originalData));
      // console.log(oldData);
      let newData = [];
      let afterData = [];
      oldData.map((item, index) => {
        if (e.measureName == item.measureName) {
          let sj = dataJS.overTimeToArr(item.data, e.demandType);
          vm.toalDataTwo[index] = sj;
          // console.log(sj);
          sj.forEach((item) => {
            afterData.push(item.value.toFixed(2));
          });
          for (let i = 0; i < sj.length; i++) {
            newData.push(sj[0].value);
          }
        }
      });

      // console.log(afterData);

      this.echartData.forEach((item) => {
        //[1.2.3.4.5.6]   2
        indexIndex = item.series[1].name.indexOf(e.name); //2
        if (indexIndex > -1) {
          // console.log(item);
          // item.series[1].data=newData
          // console.log(item)
        }
      });
      // console.log(afterData);
      // console.log(this.echartData[index].series);
      let echartData = JSON.parse(JSON.stringify(this.echartData));

      echartData[index].series[1].data = afterData;
      // this.echartData = echartData;

      let tzData = [];
      this.echartData.forEach((item) => {
        //[1.2.3.4.5.6]   2
        tzData.push(item.series[1].data);
      });

      // console.log(vm.toalDataTwo);
      let allechartdata = vm.getAlldata(vm.toalDataTwo);
      vm.allechartdataTwo = allechartdata;
      // console.log(allechartdata);
      let allobj = JSON.parse(JSON.stringify(vm.topechart));
      allobj.series[1].data = [];

      for (let z = 0; z < allechartdata.length; z++) {
        allobj.series[1].data.push(allechartdata[z].value.toFixed(2));
      }
      let obj = vm.getTableDataTwo();
      // vm.getTableDataTwo();
      // console.log(obj);
      return obj;
    },
    getTableData() {
      let vm = this;

      console.log(vm.allechartdata);
      console.log(vm.allechartdataTwo);
      if (vm.allechartdata.length == 0 || vm.allechartdataTwo == 0) {
        this.maxValue = "-";
        this.maxCost = "-";
        this.maxValueTwo = "-";
        this.Cost = "-";
        return;
      }
      const max = vm.allechartdata.reduce((prev, current) =>
        prev.value > current.value ? prev : current
      );
      console.log(max);
      const maxTwo = vm.allechartdataTwo.reduce((prev, current) =>
        prev.value > current.value ? prev : current
      );
      console.log(maxTwo);
      this.maxValue = max.value.toFixed(2);
      this.maxCost = (max.value * 32).toFixed(2);
      this.maxValueTwo = (maxTwo.value * 32).toFixed(2);
      this.Cost = (maxTwo.value * 32 - max.value * 32).toFixed(2);
      console.log(this.tableDataTwo);
      if (this.tableDataTwo != 0) {
        this.tableDataTwo[1].maxValue = maxTwo.value.toFixed(2);
        this.tableDataTwo[1].timeTwo = maxTwo.time;
        this.tableDataTwo[1].maxCost = (maxTwo.value * 32).toFixed(2);
        this.tableDataTwo[1].Cost = (
          maxTwo.value * 32 -
          max.value * 32
        ).toFixed(2);
      }

      // let obj = {
      //   timeTwo: maxTwo.time,
      //   maxValue: maxTwo.value,
      //   maxCost: max.value * 32,
      //   Cost: (maxTwo.value * 32 - max.value * 32).toFixed(2)
      // };
      // return obj;
    },

    getTableDataTwo() {
      let vm = this;
      if (vm.allechartdata.length == 0 || vm.allechartdataTwo == 0) {
        this.maxValue = "-";
        this.maxCost = "-";
        this.maxValueTwo = "-";
        this.Cost = "-";
        return;
      }
      // console.log(vm.allechartdata);
      // console.log(vm.allechartdataTwo);
      const max = vm.allechartdata.reduce((prev, current) =>
        prev.value > current.value ? prev : current
      );
      // console.log(max);
      const maxTwo = vm.allechartdataTwo.reduce((prev, current) =>
        prev.value > current.value ? prev : current
      );
      // console.log(maxTwo);

      let obj = {
        timeTwo: maxTwo.time,
        maxValue: maxTwo.value.toFixed(2),
        maxCost: (max.value * 32).toFixed(2),
        Cost: (maxTwo.value * 32 - max.value * 32).toFixed(2),
      };
      return obj;
    },

    getAlldata(e) {
      let resData = e;
      let newData = [];
      let jump = {};
      resData.map((item) => {
        item.map((temp) => {
          jump.hasOwnProperty(temp.time)
            ? (jump[temp.time] += temp.value)
            : (jump[temp.time] = temp.value);
        });
      });
      let arr = [];
      for (const key in jump) {
        if (jump.hasOwnProperty(key)) {
          const element = jump[key];
          arr.push({
            time: key,
            value: element,
          });
        }
      }
      // console.log(arr);
      return arr;
    },

    saveProject() {
      console.log("123");
      this.dialogVisible = true;
      console.log(this.tableData);
    },
    updata() {
      let vm = this;
      console.log(this.form);
      console.log(this.selectNodes);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$api.nhtj
            .saveDemandScheme(
              0,
              this.form.name,
              this.form.displayName,
              "",
              this.selectNodes[0].id,
              this.tableData
            )
            .then((res) => {
              console.log(res);
              vm.$message({
                message: "新增成功！",
                type: "success",
              });
              vm.form = {};
              vm.dialogVisible = false;
              // vm.gettableBottom();
            });
        }
      });
    },
    PlanRecord() {
      console.log("321");
      this.showpage = false;
    },
    backpage(e) {
      console.log(e);
      this.showpage = e[0];
      this.backcheck = e[1];
      console.log(this.backcheck);
      // this.gettableBottom();
      setTimeout(() => {
        this.$refs.tree.setCurrentKey(this.backcheck.id);
      }, 200);
    },

    getEchart(obj) {
      console.log(obj);
      let this_ = this;
      this.myChart = this.$echarts.init(document.getElementById("echartsId"));
      var option = {
        title: {
          text: obj.title,
          left: "center",
        },
        grid: {
          x: 80,
          y: 50,
          x2: 50,
          y2: 60,
          borderWidth: 10,
          width: "90%",
        },
        
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: obj.legend,
          top: "6%",
          icon: "line",
        },

        // dataZoom: [
        //   {
        //     type: "inside",
        //     show: true,
        //     realtime: true
        //   },
        //   {
        //     show: true,
        //     realtime: true,
        //     end: 100,
        //     type: "slider",
        //     width: "92%",
        //     left: "center"
        //   }
        // ],
        toolbox: {
          show: true,
          feature: {
            // dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar"] },
            // restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: obj.length,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
          },
        ],
        series: obj.series,
        //  [
        //   {
        //     name: obj.legend,
        //     data: obj.dataone,
        //     type: "line",
        //     smooth: true
        //     // markLine: {
        //     //   // symbol: "none", //去掉警戒线最后面的箭头
        //     //   label: {
        //     //     formatter: "{c}" + "%",
        //     //     position: "end" //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
        //     //   },
        //     //   data: [
        //     //     {
        //     //       silent: false, //鼠标悬停事件  true没有，false有
        //     //       lineStyle: {
        //     //         //警戒线的样式  ，虚实  颜色
        //     //         type: "solid",
        //     //         color: "#FA3934"
        //     //       },
        //     //       yAxis: this.warnValue // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
        //     //     }
        //     //   ]
        //     // }
        //   }
        // ]
      };

      this_.myChart.setOption(option, true);
      if (this_.myChart) {
        window.addEventListener("resize", function () {
          this_.myChart.resize();
        });
      }
    },

    //将扁平化数组转化为tree结构
    toTree(list, parId) {
      let len = list.length;
      function loop(parId) {
        let res = [];
        for (let i = 0; i < len; i++) {
          let item = list[i];
          if (item.parentId == parId) {
            item.children = loop(item.id);
            res.push(item);
          }
        }
        return res;
      }
      return loop(parId);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //处理数据
    checkData(e) {
      let data = e.data;
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].data.data.length == []) {
          arr.push("-");
        } else {
          for (let j = 0; j < data[i].data.data.length; j++) {
            arr.push((data[i].data.data[j].value * 100).toFixed(2));
          }
        }
      }
      // console.log(arr);
      return arr;
    },
  },
};
</script>
<style  lang="scss" scoped>
.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  width: 260px;
  background: #ffffff;
}
.right-content {
  overflow: auto;
  flex: 1;
  flex-flow: column;
  margin-left: 14px;
  position: relative;
}
.pane {
  margin-top: 14px;
  height: calc(100% - 50px);
}
.echarts-warp {
  width: 100%;
  padding: 14px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #dedcdc;
}
.toptitle {
  display: flex;
  justify-content: center;
  height: 120px;
}
.topcontent {
  width: 20%;
  background: #fff;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border-radius: 7px;
  div:first-child {
    font-size: 1rem;
    color: #fff;
  }
  div:last-child {
    font-size: 2rem;
    color: #fff;
  }
}
.echart-content {
  margin-top: 10px;
}
.lineEchart {
  background: #fff;
  width: 100%;
  height: 365px;
}
.table {
  margin-top: 10px;
}
.bottomtable {
  margin-top: 10px;
}
::v-deep.el-textarea {
  .el-textarea__inner {
    height: 300px;
  }
}
::v-deep.block {
  .el-slider__marks {
    .el-slider__marks-text:first-child {
      left: 1% !important;
    }
    .el-slider__marks-text:last-child {
      left: 98.5% !important;
    }
  }
  .el-slider__bar {
    background-color: initial;
  }
}

@media screen and (max-width: 1440px) {
  .tab-pane {
    height: 480px;
    overflow-y: auto;
  }
}
</style>
